<template>
    <div class="flexible-packaging-card" :class="{'active' : active}">
        <div class="d-flex justify-content-center position-relative">
            <img class="img-fluid card-pb card-image" :src="icon">

            <div v-if="addArrows" class="position-absolute inset-0 d-flex justify-content-between align-items-center" style="margin-inline: -8px">
                <div> <i class="las la-angle-left"></i> </div>
                <div> <i class="las la-angle-right"></i> </div>
            </div>
        </div>
        <p class="mb-2 fs-2 fw-700">{{ title }}</p>
        <p class="fs-5">{{ description }}</p>
    </div>
</template>

<script>
export default {
    props: ['title', 'description', 'icon', 'active', 'addArrows'],
}
</script>

<style lang="scss" scoped>
    .flexible-packaging-card {
        max-width: 273px;

        .card-image {
            max-height: 216px;
        }
    }

    @media (max-width: 615px) {
        .flexible-packaging-card {
            max-width: 100%;

            .card-image {
                max-height: 174px;
            }
        }
    }
</style>

